var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Print")]),_c('vs-button',{attrs:{"size":"small"},on:{"click":_vm.print}},[_vm._v("Test Print")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }